
      import API from "!../../../../node_modules/style-loader/dist/runtime/injectStylesIntoStyleTag.js";
      import domAPI from "!../../../../node_modules/style-loader/dist/runtime/singletonStyleDomAPI.js";
      import insertFn from "!../../../../node_modules/style-loader/dist/runtime/insertBySelector.js";
      import setAttributes from "!../../../../node_modules/style-loader/dist/runtime/setAttributesWithoutAttributes.js";
      import insertStyleElement from "!../../../../node_modules/style-loader/dist/runtime/insertStyleElement.js";
      
      import content, * as namedExport from "!!../../../../node_modules/css-loader/dist/cjs.js!../../../../webpack/loaders/mosy-strip-bom-loader/mosy-strip-bom-loader.js!../../../../node_modules/sass-loader/dist/cjs.js??ruleSet[1].rules[11].use[3]!./mOffice.scss";
      
      

var options = {};

;
options.setAttributes = setAttributes;

      options.insert = insertFn.bind(null, "head");
    
options.domAPI = domAPI;
options.insertStyleElement = insertStyleElement;

var update = API(content, options);



export * from "!!../../../../node_modules/css-loader/dist/cjs.js!../../../../webpack/loaders/mosy-strip-bom-loader/mosy-strip-bom-loader.js!../../../../node_modules/sass-loader/dist/cjs.js??ruleSet[1].rules[11].use[3]!./mOffice.scss";
       export default content && content.locals ? content.locals : undefined;
